import React from 'react'
import styled from 'styled-components'
import Navbar from '../components/Navbar'

const Hero = props => (
  <Wrapper>
    <Navbar />
    <div className="container">
      <div className="heading">
        <h1>{props.title}</h1>
        <p className="subhead">{props.subtitle}</p>
      </div>
    </div>
  </Wrapper>
)

export default Hero

const Wrapper = styled.div`
  color: #fff;
  text-align: center;
  width: 100%;
  overflow: hidden;
  position: relative;

  & > .container {
    position: relative;
    padding: 140px 0 120px;
    @media (max-width: 768px) {
      padding: 120px 0 80px;
    }
    @media (max-width: 600px) {
      padding: 100px 0 20px;
    }
  }
  .heading {
    margin: 0 auto;
    position: relative;
    z-index: 10;
    h1 {
      font-size: 43px;
      line-height: 1.2;
      width: 90%;
      max-width: 800px;
      margin: 0 auto 10px;
      br {
        display: none;
      }
      @media (max-width: 768px) {
        font-size: 40px;
      }
      @media (max-width: 600px) {
        font-size: 34px;
        margin-bottom: 15px;
        br {
          display: block;
        }
      }
    }
    p.subhead {
      font-size: 20px;
      line-height: 1.3;
      width: 90%;
      margin: 0 auto 30px;
      max-width: 600px;
      opacity: 0.8;
      @media (max-width: 768px) {
        font-size: 22px;
      }
      @media (max-width: 600px) {
        font-size: 20px;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Hero.js